import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  link: {
    id: 'venue-supply.top-section.link',
    defaultMessage: 'Explore all studios',
  },
  subtitle: {
    id: 'venue-supply.top-section.subtitle',
    defaultMessage: 'Cycling, strength training, yoga - choose any class, anywhere, with one flexible membership.',
  },
  title: {
    id: 'venue-supply.top-section.title',
    defaultMessage: 'Try classes at top studios nearby',
  },
});
